/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { AbstractRestService, identity, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';

import { FranchiseReportFilterListDto } from './franchise-monthly.dto';

@Injectable()
export class FranchiseMonthlyRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  init(): Observable<FranchiseReportFilterListDto> {
    return this.httpGet(`${this.bp}/franchise-monthly`, identity<FranchiseReportFilterListDto>());
  }

  update(reportFilter: FranchiseReportFilterListDto): Observable<FranchiseReportFilterListDto> {
    return this.httpPut(`${this.bp}/franchise-monthly`, reportFilter, identity<FranchiseReportFilterListDto>());
  }
}
